(function () {
  var form = document.getElementById('form-registro-mayoreo');
  if (!form) return;

  var btnText = document.getElementById('btn-submit-text');
  var btnSpinner = document.getElementById('btn-spinner');
  var msgSuccess = document.getElementById('msg-success');
  var msgError = document.getElementById('msg-error');
  var WEBHOOK_URL = form.dataset.webhookUrl;

  var rfcRegex = /^[A-Z&Ñ]{3,4}[0-9]{6}[A-Z0-9]{3}$/;

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var rfc = form.rfc.value.trim().toUpperCase();
    if (!rfcRegex.test(rfc)) {
      msgError.textContent = 'El RFC no tiene un formato válido. Ejemplo: XAXX010101000';
      msgError.style.display = 'block';
      return;
    }

    var data = {
      nombre: form.nombre.value.trim(),
      empresa: form.empresa.value.trim(),
      rfc: rfc,
      email: form.email.value.trim().toLowerCase(),
      telefono: form.telefono.value.trim(),
      ciudad: form.ciudad.value.trim(),
      descripcion: form.descripcion.value.trim(),
      como_nos_encontro: form.como_nos_encontro.value,
      fuente: 'shopify-form',
      timestamp: new Date().toISOString()
    };

    btnText.style.display = 'none';
    btnSpinner.style.display = 'inline-block';
    form.querySelector('button[type="submit"]').disabled = true;
    msgError.style.display = 'none';

    fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function () {
        form.style.display = 'none';
        msgSuccess.style.display = 'block';
        window.scrollTo({ top: 0, behavior: 'smooth' });

        // Conversion "Contacto B2B" de Google Ads. La campaña "Busqueda — Mayoreo B2B"
        // optimiza hacia esta accion; sin este disparo Google puja a ciegas.
        try {
          if (typeof gtag === 'function') {
            gtag('event', 'conversion', { send_to: 'AW-1013272942/P-E9CNOH860cEO6ileMD' });
          }
        } catch (e) { /* nunca romper el registro por culpa del tracking */ }

        // Meta: la campaña "Mayoreo B2B — Distribuidores" optimizaba por vistas de pagina
        // porque nunca recibia el evento de registro. Con esto ya puede optimizar por leads.
        try {
          if (typeof fbq === 'function') {
            fbq('track', 'CompleteRegistration', { content_name: 'Registro Mayoreo' });
            fbq('track', 'Lead', { content_name: 'Registro Mayoreo' });
          }
        } catch (e) { /* idem */ }
      })
      .catch(function (err) {
        console.error('Error enviando formulario:', err);
        msgError.textContent = 'Ocurrió un error al enviar tu solicitud. Intenta de nuevo o escríbenos a info@matcompanyparfum.com';
        msgError.style.display = 'block';
        btnText.style.display = 'inline';
        btnSpinner.style.display = 'none';
        form.querySelector('button[type="submit"]').disabled = false;
      });
  });
})();
